module.exports = __webpack_public_path__ + "assets/img/e550682c1fdcbe89475c3c3d678e8e5f.png";